import React, { FC, useCallback, useContext } from 'react';
import AnimatedCard from '../../../AnimatedCard';
import { observer } from 'mobx-react-lite';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { getSVG } from '@/components/Common/styles/mixins';
import styles from './index.module.scss';

const InterparkEventCard: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v10/${path}`), []);
  return (
    <AnimatedCard
      type={'gray'}
      className={styles.cardContainer}
      supTitle={<div className={styles.cardSupTitle}>카드 혜택 2</div>}
      title={
        <div className={styles.title}>
          공항 라운지 <br />
          <span className={styles.blue}>연 2회 무료</span> <br />
          <span className={styles.subDescription}>NOL 카드 국내외겸용(Visa Platinum / Amex Platinum) 전용</span>
        </div>
      }
      image={<img className={styles.image} src={getResourcePath('nol-card-lounge.png')} alt={'토피 멤버쉽 이벤트'} />}
      description={{
        bold: 'NOL, NOL 인터파크(NOL 인터파크투어/NOL 티켓),트리플에서 NOL카드로 해외 여행 상품 100만원 이상 이용 시',
        normal: ' • 이용실적조건 등은 자세히 보기 확인\n' + ' • 서비스 유효기간 : 2026년 12월 31일까지\n',
      }}
      onDetailClick={() => (store.isLoungeBottomSheetOpen = true)}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: '해외여행·공연·오프라인 혜택까지 NOL 카드 이벤트',
        motherPageVersion: store.version,
        motherPageSectionType: '이벤트',
        motherPageSectionName: '공항 라운지 연 2회 무료',
        motherPageSectionNameSubTitle: '',
        deepLinkUri: '',
      }}
    />
  );
};

export default observer(InterparkEventCard);
